import { staticConnectionIds } from "@src/constants/integration-provider.model";
import HttpClient from "../utils/http-client";

export class IntegrationService extends HttpClient {
  async rollbackOrgData(orgCodes) {
    return await this.http.post(
      `/integrations/execution/sync/rollback`,
      orgCodes,
    );
  }

  async syncByConnection(connectionId, userId, orgCode) {
    return await this.http.post(
      `/integrations/connection/${connectionId}/sync`,
      undefined,
      { params: { user_id: userId, client_code: orgCode } },
    );
  }

  async syncByProvider(providerName, userId, orgCode) {
    return await this.http.post(
      `/integrations/providers/${providerName}/sync`,
      undefined,
      { params: { user_id: userId, client_code: orgCode } },
    );
  }

  async getConnectionsForOrg(orgCode) {
    return await this.http.get(`/integrations/connection`, {
      params: { client_code: orgCode },
    });
  }

  async getProviders(params = { includeDisabled: false }) {
    return await this.http.get(`/integrations/providers`, { params });
  }

  async getProviderIconRect(providerId) {
    return await this.http.get(`/integrations/icon-rect`, {
      params: { provider_id: providerId },
    });
  }

  async getAllConnectionHistory(offset = 0, take = 5) {
    return await this.http.get(`/integrations/connection/last`, {
      params: {
        includeConnectionIds: staticConnectionIds,
        offset,
        take,
      },
      paramsSerializer: { indexes: null },
    });
  }

  async getSyncErrors(connectionId, jobExecutionId, orgCode) {
    const apiUrl = `/integrations/connection/${connectionId}/sync/errors/${jobExecutionId}`;
    const params = orgCode ? { clientCode: orgCode } : {};
    return await this.http.get(apiUrl, { params });
  }

  async getSyncDetails(jobExecutionId) {
    const requestConfig = {
      method: "get",
      url: `/integrations/execution/${jobExecutionId}/csv`,
    };

    return await this.downloadBlob(
      requestConfig,
      `sync-details-${jobExecutionId}`,
      "csv",
    );
  }
}
